import { render, staticRenderFns } from "./BrandResultInfo.vue?vue&type=template&id=b5fc335c"
import script from "./BrandResultInfo.vue?vue&type=script&lang=js"
export * from "./BrandResultInfo.vue?vue&type=script&lang=js"
import style0 from "./BrandResultInfo.vue?vue&type=style&index=0&id=b5fc335c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports